// FahrerNew shows FahrerForm and FahrerFormReview
import React, { Component } from 'react'
import ReactPlayer from 'react-player'

const VIDEOS = {
	lasi: '295386737',
	fscheck: '350685379'
}

class VideoDisplay extends Component {

	vimeoIdOfKenner(s) {
		return VIDEOS[s]
	}

	render () {
		const videokenner = this.props.match.params.vimeoid;
		const videoId = this.vimeoIdOfKenner(videokenner)

		return (
			<div className="row pl-3 w-100" style={{ aspectRatio: 8/5 }}>
					<ReactPlayer
            url={"https://player.vimeo.com/video/" + videoId}
            playing={true}
            loop={false}
            volume={0.8}
            muted={false}
						style={{backgroundColor: '#fff'}}
            onReady={() => console.log('onReady')}
            onStart={() => console.log('onStart')}
            onBuffer={() => console.log('onBuffer')}
            onSeek={e => console.log('onSeek', e)}
            onError={e => console.log('onError', e)}
					/>
			</div>
		)
	}
}

export default VideoDisplay;



// WEBPACK FOOTER //
// ./src/components/video/NurVideo.js